import {
  Message
} from 'view-design'
export default {
  state: {
    screenWidth: 2560,
    num: 0,
    timer: ''
  },
  getters: {
    ControlVal: state => state.ControlVal
  },
  mutations: {
    getScreenWidth (state) {
      let tmp = window.innerWidth
      if (tmp <= 768) {
        state.screenWidth = 768
      } else if (tmp > 768 && tmp <= 1024) {
        state.screenWidth = 1024
      } else if (tmp > 1024 && tmp <= 1440) {
        state.screenWidth = 1440
      } else {
        state.screenWidth = 2560
      }
    },
    addState (state, status) {
      state.num++
      state.timer = setTimeout(() => {
        state.num = 0
      }, 500)
    },
    subState (state, status) {
      state.num--
      clearTimeout(state.timer)
      if (state.num === 0) {
        Message.error('网络异常')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/app.js